import { render, staticRenderFns } from "./CustomerInquiry2.vue?vue&type=template&id=6c51c377&scoped=true"
import script from "./CustomerInquiry2.vue?vue&type=script&lang=js"
export * from "./CustomerInquiry2.vue?vue&type=script&lang=js"
import style0 from "./CustomerInquiry2.vue?vue&type=style&index=0&id=6c51c377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51c377",
  null
  
)

export default component.exports